export const EXTERNAL_TALENT_LOCK_ACTIONS = {
  MANAGE_SUBSCRIPTION: "manageSubscription",
  BUY_CREDITS: "buyCredits",
};

export const EXTERNAL_TALENT_LOCK_CONFIG = {
  aiPlan: {
    title: "Upgrade Required",
    description:
      "Natural language search is available on Professional and Enterprise plans.",
    actionLabel: "Upgrade Plan",
    actionType: EXTERNAL_TALENT_LOCK_ACTIONS.MANAGE_SUBSCRIPTION,
  },
  expired: {
    title: "Access 10,000+ external talents",
    description: "Upgrade your plan to unlock unlimited access to all features.",
    actionLabel: "Upgrade Plan",
    actionType: EXTERNAL_TALENT_LOCK_ACTIONS.MANAGE_SUBSCRIPTION,
  },
  creditsEnded: {
    title: "Access 10,000+ external talents",
    description: "Buy more credits to view external talents profile",
    actionLabel: "Buy Credits",
    actionType: EXTERNAL_TALENT_LOCK_ACTIONS.BUY_CREDITS,
  },
};

const EXPIRED_PLAN_STATUSES = ["expired", "cancelled"];

const normalizePlanText = (value = "") =>
  typeof value === "string"
    ? value.trim().replace(/^['"]+|['"]+$/g, "").toLowerCase()
    : "";

export const getCreditsBalancePayload = (creditsBalance = {}) =>
  creditsBalance?.data && typeof creditsBalance.data === "object"
    ? creditsBalance.data
    : creditsBalance || {};

const getCurrentPlanCode = (payload = {}) => payload?.planCode || "";

const hasProfessionalOrEnterprisePlan = (payload = {}) => {
  const planTokens = normalizePlanText(getCurrentPlanCode(payload))
    .split(/[^a-z0-9]+/)
    .filter(Boolean);

  return planTokens.some((token) =>
    ["professional", "enterprise", "pro"].includes(token)
  );
};

const hasExplicitExpiredPlan = (payload = {}) => {
  const normalizedStatus = normalizePlanText(
    payload?.status || payload?.subscriptionStatus
  );

  if (EXPIRED_PLAN_STATUSES.includes(normalizedStatus)) {
    return true;
  }

  return payload?.hasActivePlan === false && Boolean(getCurrentPlanCode(payload));
};

export const getExternalTalentLockState = ({
  isAiMode,
  creditsBalanceLoaded,
  creditsBalancePayload,
  availableCredits,
}) => {
  if (
    creditsBalanceLoaded &&
    hasExplicitExpiredPlan(creditsBalancePayload)
  ) {
    return "expired";
  }

  if (creditsBalanceLoaded && availableCredits <= 0) {
    return "creditsEnded";
  }

  return null;
};
